import { useEffect } from 'react';
import { useMatch } from '../store/match.js';

/** Floating reactions the opponent threw, and transient error toasts. */

export function EmojiLayer() {
  const emojis = useMatch((s) => s.emojis);
  const yourSeat = useMatch((s) => s.yourSeat);

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-24 z-40 flex justify-center">
      {emojis.map((item) => (
        <span
          key={item.id}
          className="animate-rise absolute text-4xl"
          style={{
            // Your own reactions drift left, the opponent's right, so it is
            // clear who sent what without a label.
            left: item.fromSeat === yourSeat ? '30%' : '65%',
          }}
        >
          {item.emoji}
        </span>
      ))}
    </div>
  );
}

export function ErrorToast() {
  const error = useMatch((s) => s.error);
  const dismiss = useMatch((s) => s.dismissError);

  useEffect(() => {
    if (!error) return;
    const handle = window.setTimeout(dismiss, 3000);
    return () => window.clearTimeout(handle);
  }, [error, dismiss]);

  if (!error) return null;

  return (
    <div className="fixed inset-x-3 top-3 z-50 rounded-xl bg-danger px-4 py-3 text-center text-[14px] text-white shadow-lg">
      {error}
    </div>
  );
}

export function ConnectionBanner() {
  const status = useMatch((s) => s.status);
  if (status === 'ready') return null;

  const text =
    status === 'offline' ? 'Aloqa uzildi — qayta ulanyapmiz…' : 'Ulanyapmiz…';

  return (
    <div className="fixed inset-x-0 top-0 z-50 bg-hint/90 py-1.5 text-center text-[13px] text-white">
      {text}
    </div>
  );
}
